import { render, staticRenderFns } from "./PendingProducts.vue?vue&type=template&id=1b590998"
import script from "./PendingProducts.vue?vue&type=script&lang=js"
export * from "./PendingProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports